import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import verification from "../assets/verification.png"

function Code() {
    const navigate = useNavigate()
    const pressback = () => {
        navigate("/verify")
    }
    const handlepress = () => {
        navigate("/dashboard")
    }
    return (<>
        <div className='d-flex align-items-center ps-3 pe-3' style={{ height: "100vh" }}>
            <div className='container box_div pb-5  d-flex justify-content-center' style={{ position: "relative" }}>
                <div>
                    <div className='verification_card pt-4 ps-2 pe-2'>
                        <div className='d-flex  justify-content-center'>
                            <img src={verification} />
                        </div>
                        <p className='otp_heading'>OTP Verification</p>
                        <p className='otp_text' style={{ marginTop: "-10px" }}>We have sent you four digit one time password (OTP) to your mobile.</p>
                        <p className='time_text'>1:52</p>
                        <div className='verification_inputs'>
                            <input maxLength={1} placeholder='0' className='verification_input' />
                            <input maxLength={1} placeholder='0' className='verification_input' />
                            <input maxLength={1} placeholder='0' className='verification_input' />
                            <input maxLength={1} placeholder='0' className='verification_input' />

                        </div>

                    </div>
                    <div className='code_btn' onClick={handlepress}>
                        <button className='next_btn mb-4' style={{ marginBottom: "0px" }} onClick={()=>navigate("/dashboard")} >Verify</button>
                    </div>
                    <div className='bac_div bac2_div' onClick={pressback}>
                        <p className='back_text'>Back</p>
                    </div>
                </div>
            </div>
        </div>







    </>

    )
}

export default Code